import LoginPage from '../views/LoginPage.vue'
import CompanyPage from '../views/CompanyPage.vue'
import WelcomePage from '../views/WelcomePage.vue'
import ForgotPasswordPage from '../views/ForgotPasswordPage.vue'
import ResetPasswordPage from '../views/ResetPasswordPage.vue'
import CardPage from '../views/CardPage.vue'
import CardDetailsPage from '../views/CardDetailsPage.vue'
import OrderPage from '../views/OrderPage'
import OrderDetailsPage from '../views/OrderDetailsPage'
import OrderReplacementCardPage from '../views/OrderReplacementCardPage'
import OrderTerminateCardPage from '../views/OrderTerminateCardPage'
import InvoicePage from '../views/InvoicesPage'
import ServiceAndContactPage from '../views/ServiceAndContactPage'
import InvoiceSpecificationsPage from '../views/InvoiceSpecificationsPage'

import type Store from 'vuex'
import { i18n } from '../plugins/vue-i18n'
import showAlertErrorHandler from '../mixins/show-alert-error-handler'

export const loadCardDetails = async (store, cardId, to, from, next) => {
  try {
    await store.dispatch('card/loadCardDetails', cardId)
    next()
  } catch (error) {
    if (error.code === 401) {
      await next({name: 'login'})
    } else {
      await next({name: 'card'})
    }
    showAlertErrorHandler.methods.showAlertForError(error, {404: i18n.t('card.detailsNotFound')})
  }
}

export const loadOrderDetails = async (store, orderId, to, from, next) => {
  try {
    await store.dispatch('orderItems/loadOrderItems', orderId)
    next()
  } catch (error) {
    if (error.code === 401) {
      await next({name: 'login'})
    } else {
      await next({name: 'order'})
    }
    showAlertErrorHandler.methods.showAlertForError(error, {404: i18n.t('orderItem.detailsNotFound')})
  }
}

const assertSelfServiceEnabledOrRedirect = (store, next) => {
  if (!store.state.company.selfServiceStatus.selfServiceEnabled) {
    next({name: 'welcome'})
  } else {
    next()
  }
}

export default function buildRoutes (store: Store) {
  return [
    {
      path: '/',
      name: 'home'
    },
    {
      path: '/nl/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/nl/forgot-password',
      name: 'forgot-password',
      component: ForgotPasswordPage
    },
    {
      path: '/nl/reset-password',
      name: 'reset-password',
      component: ResetPasswordPage,
      beforeEnter: async (to, from, next) => {
        if (!to.query.token) {
          await next({name: 'login'})
          showAlertErrorHandler.methods.showAlert(i18n.t('resetPasswordForm.errorTokenParameterMissing'))
        } else {
          try {
            await store.dispatch('user/verifyPasswordResetToken', {resetToken: to.query.token})
            next()
          } catch (error) {
            await next({name: 'forgot-password'})
            showAlertErrorHandler.methods.showAlertForError(error, {404: i18n.t('resetPasswordForm.errorTokenInvalid')})
          }
        }
      }
    },
    {
      path: '/nl/logout',
      name: 'logout',
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetAllState')
        await next({name: 'login'})
        showAlertErrorHandler.methods.showAlert(i18n.t('generic.loggedOutNotication'))
      }
    },
    {
      path: '/nl/welcome',
      name: 'welcome',
      component: WelcomePage
    },
    {
      path: '/nl/company',
      name: 'company',
      component: CompanyPage,
      beforeEnter: async (to, from, next) => {
        try {
          await store.dispatch('company/loadCompany')
          next()
        } catch (error) {
          if (error.code === 401) {
            await next({name: 'login'})
          } else {
            await next()
          }
          showAlertErrorHandler.methods.showAlertForError(error)
        }
      }
    },
    {
      path: '/nl/card-details/index/cardId/:cardId',
      name: 'card-details',
      component: CardDetailsPage,
      beforeEnter: async (to, from, next) => {
        await loadCardDetails(store, to.params['cardId'], to, from, next)
      }
    },
    {
      path: '/nl/card',
      name: 'card',
      component: CardPage
    },
    {
      path: '/nl/order',
      name: 'order',
      component: OrderPage,
      beforeEnter: (to, from, next) => assertSelfServiceEnabledOrRedirect(store, next)
    },
    {
      path: '/nl/order/:orderId',
      name: 'order-details',
      component: OrderDetailsPage,
      beforeEnter: async (to, from, next) => {
        await assertSelfServiceEnabledOrRedirect(store, next)
        await loadOrderDetails(store, to.params['orderId'], to, from, next)
      }
    },
    {
      path: '/nl/order-replacement-card',
      name: 'order-replacement-card',
      component: OrderReplacementCardPage,
      beforeEnter: (to, from, next) => assertSelfServiceEnabledOrRedirect(store, next)
    },
    {
      path: '/nl/order-terminate-card',
      name: 'order-terminate-card',
      component: OrderTerminateCardPage,
      beforeEnter: (to, from, next) => assertSelfServiceEnabledOrRedirect(store, next)
    },
    {
      path: '/nl/invoice',
      name: 'invoice',
      component: InvoicePage
    },
    {
      path: '/nl/contact',
      name: 'contact',
      component: ServiceAndContactPage
    },
    {
      path: '/nl/invoice-specification',
      name: 'invoice-specification',
      component: InvoiceSpecificationsPage
    }
  ]
}



// WEBPACK FOOTER //
// ./src/routes/index.js